import { useBoundStore } from "../zustand/Store";

export const useHandleSelectArticle = () => {
  const updateArticleId = useBoundStore((state) => state.updateArticleId);
  const updateDate = useBoundStore((state) => state.updateDate);
  const updateEdition = useBoundStore((state) => state.updateEdition);
  const updateIsVisible = useBoundStore((state) => state.updateIsVisible);

  return async (articleID: string, date: string | undefined, edition: string | undefined) => {
    if (date && edition) {
      updateArticleId(articleID);
      updateDate(date);
      updateEdition(edition);
      updateIsVisible(true);
    }
  };
};